import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAppContext } from '../../contexts/AppContext';
import { querystring } from '../../utils/RouteHelper';

export default function UnauthenticatedRoute() {
  const { isAuthenticated } = useAppContext();

  const redirect = querystring('redirect') ? decodeURIComponent(querystring('redirect') || '') : '';

  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated) {
      void navigate(redirect === '' || redirect === null ? '/' : redirect, { replace: true });
    }
  }, [isAuthenticated]);
  return <Outlet />;
}
